import { ReactNode } from 'react';
import cx from 'classnames';
import styles from './product-availability.module.scss';
interface AvailabilityQuantityProps {
  children: ReactNode;
  isInStock?: boolean;
}

export const AvailabilityQuantity = ({
  children,
  isInStock = false
}: Readonly<AvailabilityQuantityProps>) => (
  <span
    className={cx('fw-bold px-1', {
      [styles['product-availability__line']]: !isInStock,
      [styles['product-availability__line-in-stock']]: isInStock
    })}
  >
    {children}
  </span>
);
